import axios from '@/plugins/axios'
import { yuefen } from './assets/area.js'
const ruleGenerator = {
  methods: {
    buildRule () {
      if (this.component && this.component.properties && typeof this.component.properties === 'object') {
        // 构建控件校验规则, 非表单控件返回值是一个数组
        let attr = this.component.properties
        let limitLengthComponents = ['rc-children-input', 'rc-input', 'rc-password']
        // 如果是控件隐藏,不进行校验
        if (attr.hidden) {
          return []
        }
        let clickType = this.component.componentType === 'rc-combobox' && !attr.multiple ? ['blur', 'change'] : 'blur'
        if (this.component.componentType === 'rc-data-source') {
          clickType = ['blur', 'change']
        }
        if (this.component.componentType === 'rc-radio') {
          clickType = 'change'
        }
        if (this.component.componentType === 'rc-phone') {
          if (!attr.limit) {
            attr.limit = {}
            attr.limit.rules = []
          }
          attr.limit.enable = true
          attr.limit.rules.push({ limitType: '手机号' })
        } else if (limitLengthComponents.includes(this.component.componentType)) {
          attr.limit.enable = true
          if (!attr.limit.rules.some(m => m.limitType.includes('字符长度'))) {
            attr.limit.rules.push({ limitType: '字符长度' })
          }
        }
        // 重复性校验
        if (attr.repeatability) {
          if (!attr.limit) {
            attr.limit = {}
            attr.limit.rules = []
          }
          attr.limit.enable = true
          let rule = { limitType: '重复性校验', 'tableId': this.component.archive.tableId }
          attr.limit.rules.push(rule)
        }
        // 超链接控件添加失焦校验
        if (this.component.componentType === 'rc-hyperlink') {
          if (!attr.limit) {
            attr.limit = {}
            attr.limit.rules = []
          }
          attr.limit.enable = true
          let rule = { limitType: '超链接地址校验', 'tableId': this.component.archive.tableId }
          attr.limit.triggerBlur = true
          attr.limit.rules.push(rule)
        }
        // 富文本控件添加change校验
        if (this.component.componentType === 'rc-rich-box') {
          if (!attr.limit) {
            attr.limit = {}
            attr.limit.rules = []
          }
          attr.limit.enable = true
          let rule = { limitType: '富文本必填校验', 'tableId': this.component.archive.tableId, required: this.component.properties.required }
          attr.limit.triggerBlur = false
          this.component.properties.required && attr.limit.rules.push(rule)
        }
        // TODO 不知道上面的 clickType是干啥的。上面所判断的控件部分是无法设置录入限制的
        // TODO 54期新增 录入限制 失焦校验（triggerBlur）。默认为true 所以使用 triggerBlur 代替原来的 clickType
        clickType = attr && attr.limit && attr.limit.triggerBlur ? 'blur' : 'change'
        if (this.component.componentType === 'rc-date' || this.component.componentType === 'rc-combobox') {
          clickType = 'blur'
        }
        // 传一个当前实例 实现超链接控件未归档也能拿到值实现校验
        return customRule.buildRules(attr, this.component.name, this, clickType)
      }
    },
    buildFormRule () {
      // 构建表单校验规则, 表单返回值是一个对象
      let attr = this.component.properties
      let ruleObject = {}
      // 传一个当前实例 实现超链接控件未归档也能拿到值实现校验
      ruleObject[this.component.archive.columnId] = customRule.buildRules(attr, this.component.name, this)
      return ruleObject
    }
  },
  watch: {
    'component.properties': {
      handler () {
        this.rules = this.buildRule()
      },
      deep: true
    }
  }
}

const customRule = {
  buildRules (attr, name, vm, clickType) {
    // 统一调用方法, 返回生成的规则数组
    let validatorRule = []
    if (attr.limit && attr.limit.enable) {
      let rules = attr.limit.rules
      rules.forEach(rule => {
        if (rule.limitType !== '') {
          validatorRule.push(this.generateRule(rule, name, vm, clickType))
        }
      })
    }
    // 必填校验
    validatorRule.push(this.generateRule({limitType: '是否必填', required: attr.required}, name, vm, clickType))
    return validatorRule
  },
  generateRule  (rule, name, vm, clickType) {
    // 生成校验规则
    switch (rule.limitType) {
      case '字符数':
        return { validator: this.stringLength, options: rule, trigger: clickType }
      case '字符格式':
        if (rule.stringFormat === 'english') {
          return { pattern: /^[a-zA-Z]+$/, message: '请输入英文', trigger: clickType }
        } else if (rule.stringFormat === 'number') {
          return { pattern: /^([-|\d]+)(\.\d+)?$/, message: '请输入数字', trigger: clickType }
        } else if (rule.stringFormat === 'english&number') {
          return { pattern: /^[A-Za-z0-9]+[A-Za-z0-9]+$/, message: '请输入英文加数字', trigger: clickType }
        } else if (rule.stringFormat === 'phoneNum') {
          return { pattern: /^[1](3|4|5|6|7|8|9)\d{9}$/, message: '请输入正确的手机号', trigger: clickType }
        } else if (rule.stringFormat === 'chinese') {
          return { pattern: /^[\u4e00-\u9fa5|()（）*]+$/, message: '请输入中文字符', trigger: clickType }
        } else {
          return { pattern: /^[^\u4e00-\u9fa5]+$/, message: '请输入非中文字符', trigger: clickType }
        }
      case '数值限制':
        return {validator: this.numberLimit, options: [{min: rule.min, max: rule.max}], trigger: clickType, message: `请输入数值,最大值为${rule.max},最小值为 ${rule.min}!`}
      /* case '日期限制':
        return { validator: numberLimit, trigger: 'blur' } */
      case '包含字符':
        return {validator: this.includeString, options: rule.includeString, trigger: clickType}
      case '重复性校验':
        return { validator: this.repeatability, tableId: rule.tableId, trigger: clickType }
      case '是否必填':
        return { required: rule.required, validator: this.requiredValue, message: `${name}不能为空`, trigger: clickType }
      case '手机号':
        return { pattern: /^[1](3|4|5|6|7|8|9)\d{9}$/, message: '请输入正确的手机号', trigger: clickType }
      case '身份证':
        return { validator: this.verificationIdCard, message: '请输入正确的身份证号', trigger: clickType }
      case '字符长度':
        return { validator: this.stringMaxLength, options: rule, trigger: clickType }
      case '正则':
        return { validator: this.validatorPattern(rule), trigger: clickType, message: rule.regExpMessage }
      case '超链接地址校验':
        return { validator: this.validatorHyperlink(vm), trigger: clickType, message: '链接格式不正确，需要以http:// 或 https:// 开头' }
      case '富文本必填校验':
        return { required: rule.required, validator: this.validatorRichBoxRequired(vm), message: `${name}不能为空`, trigger: clickType }
      default:
        throw Error(`待扩展的类型 ${rule.limitType}`)
    }
  },
  requiredValue (rule, value, callback) {
    if (!rule.required) {
      callback()
    } else if (value && !value.toString().trim()) {
      callback(new Error(rule.message))
    } else if (!value && value !== 0) {
      callback(new Error(rule.message))
    } else {
      callback()
    }
  },

  numberLimit (rule, value, callback) {
    // 数字范围校验
    let message = rule.message
    if (isNaN(value)) {
      callback(new Error(message))
    }
    if (rule.options[0].min !== '' && parseFloat(value) < parseFloat(rule.options[0].min)) {
      callback(new Error(message))
    }
    if (rule.options[0].max !== '' && parseFloat(value) > parseFloat(rule.options[0].max)) {
      callback(new Error(message))
    }
    callback()
  },

  stringLength (rule, value, callback) {
    if (value) {
      if (value.toString().length < Number(rule.options.min)) {
        callback(new Error(`请至少输入${rule.options.min}位`))
      }
      if (value.toString().length > Number(rule.options.max)) {
        callback(new Error(`请至多输入${rule.options.max}位`))
      }
    }
    callback()
  },
  stringMaxLength (rule, value, callback) {
    if (value && value && value.toString().length > 300) {
      callback(new Error(`字符长度最长为300个字符`))
    }
    callback()
  },
  includeString (rule, value, callback) {
    // 包含校验
    rule.options.forEach(options => {
      if (!value) {
        return callback()
      } else {
        value = value.toString()
      }

      if (options.type === 'contain') {
        if (!value.includes(options.value)) {
          callback(new Error(`请输入包含 ${options.value} 的字符`))
        }
      } else {
        if (value.includes(options.value)) {
          callback(new Error(`请输入不包含 ${options.value} 的字符`))
        }
      }
    })
    callback()
  },

  repeatability (rule, value, callback) {
    axios.get('/form-api/runtime/checkoutRepeatValue', {
      params: {
        tableId: rule.tableId,
        columnId: this.field,
        value: value
      }
    }).then((res) => {
      callback()
    }).catch((error) => {
      // TODO error.message ?
      callback(new Error(error))
    })
  },

  verificationIdCard (rule, value, callback) {
    if (value === '' || value === undefined || value === null) {
      return callback()
    }
    if (value.length !== 15 && value.length !== 18) {
      return callback(new Error(rule.message))
    }
    let mm
    let dd
    if (value.length === 15) {
      mm = value.substr(8, 2)
      dd = value.substr(10, 2)
    } else if (value.length === 18) {
      mm = value.substr(10, 2)
      dd = value.substr(12, 2)
    }
    // 62th 取消地址码的校验
    if (!yuefen[mm] || parseInt(dd, 10) < 1 || parseInt(dd, 10) > yuefen[mm]) {
      return callback(new Error(rule.message))
    }
    let jiaQuanYinZi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    let valide = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
    let sum = 0
    for (let i = 0; i < value.length - 1; i++) {
      sum += value.charAt(i) * jiaQuanYinZi[i]
    }
    // TODO 不能直接 使用 !(result), !0 === true 等项目升级可以使用 ??
    const result = valide[sum % 11]
    const isEmpty = str => str === undefined || str === null
    if (isEmpty(result) || result.toString().toUpperCase() !== value.charAt(value.length - 1).toString().toUpperCase()) {
      return callback(new Error(rule.message))
    }
    return callback()
  },

  validatorPattern (customRule) {
    return (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {
        return callback()
      }
      let reg
      try {
        // eslint-disable-next-line no-eval
        reg = new RegExp(eval(customRule.regExp))
      } catch (e) {
        return callback()
      }
      return reg.test(value) ? callback() : callback(new Error(customRule.regExpMessage || '正则不匹配'))
    }
  },

  validatorHyperlink (vm) {
    return (rule, value, callback) => {
      let linkValue = value
      if (!vm.component.archive.enable) linkValue = vm.tempValue
      let httpReg = new RegExp('(https?|ftp|file)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]', 'g')
      if (linkValue && !httpReg.test(linkValue)) {
        callback(new Error(`链接格式不正确，需要以http:// 或 https:// 开头`))
      }
      callback()
    }
  },

  SrcRegFun (html) {
    let imgReg = /<img.*?(?:>|\/>)/gi // 匹配图片中的img标签
    let imgArr = html.match(imgReg) // 筛选出所有的img
    let iframeReg = /<iframe.*?(?:>|\/>)/gi // 匹配图片中的iframe标签
    let iframeArr = html.match(iframeReg) // 筛选出所有的img
    // eslint-disable-next-line no-useless-escape
    let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i // 匹配图片/iframe中的src
    let hasContent = false
    hasContent = imgArr ? imgArr.some(m => m.match(srcReg)[1]) : false
    hasContent = hasContent ? true : iframeArr ? iframeArr.some(m => m.match(srcReg)[1]) : false
    return hasContent
  },
  validatorRichBoxRequired (vm) {
    return (rule, value, callback) => {
      let data = vm.editor.txt.text()
      let html = vm.editor.txt.html()
      if (!rule.required) {
        callback()
      } else {
        if (!data) {
          if (html) {
            // 富文本中的表情和图片、视频，data是空
            let hasContent = this.SrcRegFun(html)
            if (hasContent) {
              callback()
            } else {
              callback(new Error(rule.message))
            }
          }
          callback(new Error(rule.message))
        } else {
          // 将回车键替换成空格
          data = data.replace(/(↵)/g, '')
          // 删除所有的空格标签
          data = data.replace(/&nbsp;/g, '')
          // 去除空内容
          data = data.trim()
          // 富文本中的表情和图片、是视频(插入空表格data是[&nbsp;],在校验一遍)
          let hasContent = this.SrcRegFun(html)
          if (!data && !hasContent) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        }
      }
    }
  }

}
export { ruleGenerator, customRule }



// WEBPACK FOOTER //
// ./src/components/form/runtime/components/rule.js